import React from "react";
import "./shippingAndDeliveryPolicy.scss";
import SEO from "components/seo/SEO";

const ShippingAndDeliveryPolicy = () => {
  return (
    <div className="shipping-and-delivery-policy">
      <SEO
        title="Shipping And Delivery Policy | KRISTIVE"
        description="Learn how KRISTIVE delivers your favorite fragrances. Detailed information on shipping timelines, delivery processes, and tracking for a seamless shopping experience."
      />
      <div className="title">Shipping & Delivery Policy</div>
      <div className="main-container">
        <div>
          <div>
            <strong>Last updated on:</strong> Sep 14, 2025
          </div>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          For International buyers, orders are shipped and delivered through
          registered international courier companies and/or International speed
          post only. For domestic buyers, orders are shipped through registered
          domestic courier companies and /or speed post only. Orders are shipped
          within 0-7 days or as per the delivery date agreed at the time of
          order confirmation and delivering of the shipment subject to Courier
          Company / post office norms. KRISTIVE is not liable for any delay in
          delivery by the courier company / postal authorities and only
          guarantees to hand over the consignment to the courier company or
          postal authorities within 0-7 days rom the date of the order and
          payment or as per the delivery date agreed at the time of order
          confirmation. Delivery of all orders will be to the address provided
          by the buyer. Delivery of our services will be confirmed on your mail
          ID as specified during registration. For any issues in utilizing our
          services you may contact our helpdesk on 8511815568 or
          support@kristive.com
        </div>
      </div>
    </div>
  );
};

export default ShippingAndDeliveryPolicy;
